// export const drawerModal = () => {
//     return {
//         visible: false,
//         item: {},
//
//         show(options) {
//             this.item = options;
//             this.visible = true;
//
//             this.$nextTick(() => {
//                 if (window.Formie && typeof window.Formie.initForm === 'function') {
//                     document.querySelectorAll('form[data-fui-form]').forEach(form => {
//                         window.Formie.initForm(form);
//                     });
//                 }
//             });
//
//         },
//
//         toggle() {
//             this.visible = !this.visible;
//         },
//     };
// };

export const drawerModal = (id) => {
    return {
        visible: false,
        item: {},

        show(options) {
            this.item = options;
            this.visible = true;

            const isAddressDrawer = options.type === 'address';
            const isPasswordDrawer = options.type === 'password';

            if (isPasswordDrawer) {
                this.$nextTick(() => {
                    const visibleForm = document.querySelector('#password-drawer form:is(:not([hidden]))');

                    if (visibleForm && window.Formie?.initForm) {
                        window.Formie.initForm(visibleForm);
                    }
                });
            }

            if (isAddressDrawer) {
                this.$nextTick(() => {
                    // Re-init only visible form
                    const visibleForm = document.querySelector('#address form:is(:not([hidden]))');

                    if (visibleForm && window.Formie?.initForm) {
                        // window.Formie.initForm(visibleForm);
                        window.Formie.initForm(visibleForm);

                        // Run the same logic as your event listener directly
                        window.Formie.refreshForCache(visibleForm.getAttribute('id'));
                    }

                    const forms = document.querySelectorAll('#address form');

                    forms.forEach((form) => {
                        const addressTitle = document.getElementById('address-title');
                        const addressIdField = form.querySelector('[name="addressId"]');

                        if (addressTitle && addressIdField) {
                            if (this.item && this.item.id) {
                                addressTitle.textContent = window.translations.editAddress;
                            } else {
                                addressTitle.textContent = window.translations.addAddress;
                            }
                        }

                        if (addressIdField) {
                            addressIdField.value = this.item?.id || '';

                            const hasValue = addressIdField.value.trim() !== '';
                            const deleteForm = document.getElementById('delete-address');

                            if (deleteForm) {
                                if (hasValue) {
                                    deleteForm.classList.remove('hidden');
                                } else {
                                    deleteForm.classList.add('hidden');
                                }
                            }
                        }

                        for (const [key, value] of Object.entries(this.item)) {
                            const field = form.querySelector(`[name$="[${key}]"], [name="${key}"]`);

                            if (field) {
                                if (field.type === 'checkbox') {
                                    field.checked = Boolean(value);
                                } else {
                                    field.value = value;
                                }
                            }
                        }

                        const syncCheckbox = (form, name) => {
                            const hidden = form.querySelector(`[name="${name}"]`);
                            const checkbox = form.querySelector(`[data-fui-id="addresses-${name}"]`);

                            if (hidden && checkbox) {
                                checkbox.checked = hidden.value === '1';

                                checkbox.addEventListener('change', (e) => {
                                    hidden.value = e.target.checked ? '1' : '';
                                });
                            }
                        };

                        const hideCheckbox = (form, name) => {
                            const hidden = form.querySelector(`[name$="[${name}]"], [name="${name}"]`);
                            const checkbox = form.querySelector(`[data-fui-id="addresses-${name}"]`);

                            if (hidden && checkbox) {
                                hidden.closest('[data-fui-field-count]').remove();
                                checkbox.closest('[data-fui-field-count]').remove();
                            }
                        };

                        if (window.currentUser) {
                            syncCheckbox(form, 'isPrimaryShipping');
                            syncCheckbox(form, 'isPrimaryBilling');
                        } else {
                            hideCheckbox(form, 'isPrimaryShipping');
                            hideCheckbox(form, 'isPrimaryBilling');
                        }
                    });

                    // Setup country change listener
                    const countryField = document.querySelector('[name="countryCode"], [name$="[countryCode]"]');
                    const adminAreaSelect = document.querySelector('[name="administrativeArea"], [name$="[administrativeArea]"]');

                    const updateAdminAreaOptions = (countryCode) => {
                        const adminAreaWrapper = adminAreaSelect.closest('[data-fui-field-count]');

                        // Hide and disable if GB
                        // if (countryCode === 'GB') {
                        //     if (adminAreaSelect) {
                        //         adminAreaSelect.required = false;
                        //         adminAreaSelect.value = '';
                        //         adminAreaSelect.disabled = true;
                        //     }
                        //     if (adminAreaWrapper) {
                        //         adminAreaWrapper.classList.add('hidden');
                        //     }
                        //
                        //     return;
                        // }

                        // Clear old options
                        if (!adminAreaSelect) {
                            return;
                        }

                        // Clear previous options
                        adminAreaSelect.disabled = false;
                        adminAreaSelect.innerHTML = '';

                        if (window.allStates && window.allStates[countryCode]) {
                            const states = window.allStates?.[countryCode] || [];

                            if (states.length) {
                                adminAreaWrapper?.classList.remove('hidden');

                                // Add a default empty option
                                const defaultOption = document.createElement('option');

                                defaultOption.value = '';
                                defaultOption.textContent = 'Please select';
                                defaultOption.disabled = true;
                                defaultOption.selected = true;
                                adminAreaSelect.appendChild(defaultOption);

                                // Populate states
                                states.forEach((state) => {
                                    const option = document.createElement('option');

                                    option.value = state.value;
                                    option.textContent = state.label;
                                    adminAreaSelect.appendChild(option);
                                });

                                // Restore previously selected state if any
                                if (this.item.administrativeArea) {
                                    adminAreaSelect.value = this.item.administrativeArea;
                                }

                                // Make field required
                                adminAreaSelect.required = true;
                            } else {
                                // Hide wrapper and clear value if no states
                                // adminAreaWrapper.style.display = 'none';
                                adminAreaWrapper?.classList.add('hidden');
                                adminAreaSelect.value = '';

                                // Remove required attribute
                                adminAreaSelect.required = false;
                            }
                        } else {
                            // No states available
                            adminAreaWrapper?.classList.add('hidden');
                            adminAreaSelect.value = '';
                            adminAreaSelect.required = false;
                        }
                    };

                    const updateLocalityAndPostalCodeVisibility = (countryCode) => {
                        const localityField = document.querySelector('[name="locality"], [name$="[locality]"]');
                        const postalCodeField = document.querySelector('[name="postalCode"], [name$="[postalCode]"]');

                        // Hide options based on selected countries
                        const hidePostal = [
                            'AE',
                            'AG',
                            'BS',
                            'BO',
                            'BV',
                            'BZ',
                            'CI',
                            'CW',
                            'DM',
                            'GD',
                            'GY',
                            'HK',
                            'JM',
                            'LC',
                            'LY',
                            'MO',
                            'MS',
                            'PA',
                            'PS',
                            'QA',
                            'SR',
                            'SX',
                            'TF',
                            'TL',
                            'TT',
                        ].includes(countryCode);
                        const hideLocality = ['AE', 'KY', 'MO'].includes(countryCode);

                        // --- Locality ---
                        if (localityField) {
                            localityField.required = !hideLocality;
                            localityField.disabled = hideLocality;
                            localityField.closest('[data-fui-field-count]')?.classList.toggle('hidden', hideLocality);
                        }

                        // --- Postal Code ---
                        if (postalCodeField) {
                            postalCodeField.required = !hidePostal;
                            postalCodeField.disabled = hidePostal;
                            postalCodeField.closest('[data-fui-field-count]')?.classList.toggle('hidden', hidePostal);
                        }
                    };

                    if (countryField) {
                        // Initial population
                        updateAdminAreaOptions(countryField.value);
                        updateLocalityAndPostalCodeVisibility(countryField.value);

                        // Listen for changes
                        countryField.addEventListener('change', (e) => {
                            const newCountry = e.target.value;

                            this.item.locality = '';
                            this.item.postalCode = '';
                            this.item.administrativeArea = '';

                            // Update administrativeArea select options
                            updateAdminAreaOptions(newCountry);
                            updateLocalityAndPostalCodeVisibility(newCountry);
                        });
                    }

                    // Re-init Formie if needed
                    if (window.Formie && typeof window.Formie.initForm === 'function') {
                        document.querySelectorAll('form[data-fui-form]').forEach((form) => {
                            window.Formie.initForm(form);
                        });
                    }
                });
            }
        },

        toggle() {
            this.visible = !this.visible;
        },

        init() {
            window.addEventListener(`drawer:${id}`, (e) => {
                this.show(e.detail);
            });
        },
    };
};

window.showDrawerModal = (drawerId, item = {}) => {
    window.dispatchEvent(
        new CustomEvent(`drawer:${drawerId}`, {
            detail: item,
        }),
    );
};
